// import { authHeader } from './auth-header';
import Api from "./PreApiHandler";

export default {
    login,
    logout,
    register,
    requestPasswordReset,
    passwordReset,
    activateUser,
    tgBotPrepare,
    tgBotPoll,
    miniappVerify,
    miniappLink,
    miniappAutoRegister,
    getCdnKey,
    setTimezone,
    setReportCurrency,
    setEmail,
    sendEmailCode,
    resolveEmailConflict,
    setPassword,
    setCurrency,
    setLang,
    getKeyForTg,
    setAnalyticsIds
    // getAll,
};

async function login(email, password, rememberMe) {
    const request = {
        method: 'post',
        path: 'user/sign-in/login',
        body: {
            identity: email,
            password: password,
            rememberMe: rememberMe
        }
    }

    return Api.sendRequest(request)
}

async function logout() {
    const request = {
        method: 'post',
        path: 'user/sign-in/logout',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: {}
    }

    return Api.sendRequest(request)
}

function register(body) {
    const request = {
        method: 'post',
        path: 'user/sign-in/signup',
        // headers: {
        //     'Content-Type': 'application/x-www-form-urlencoded'
        // },
        body: body
    }
    return Api.sendRequest(request)
}

function requestPasswordReset(email) {
    const request = {
        method: 'post',
        path: 'user/sign-in/request-password-reset',
        body: {
            email: email
        }
    }
    return Api.sendRequest(request)
}

function passwordReset(body) {
    const request = {
        method: 'post',
        path: 'user/sign-in/reset-password',
        body
    }
    return Api.sendRequest(request)
}

// POST + JSON body: activation logs the browser in, so it must not be a GET (login-CSRF).
function activateUser(code) {
    const request = {
        method: 'post',
        path: 'user/sign-in/activation',
        body: {code: String(code)}
    }
    return Api.sendRequest(request)
}

// Login/registration by launching @graspil_bot (replaces the Telegram OIDC redirect).
// prepare registers a pending attempt for a li1 token; poll long-polls until the user confirms
// in the bot, then the browser session is issued.
function tgBotPrepare(body, params = {}) {
    const request = {
        method: 'post',
        path: 'user/sign-in/tg-bot-prepare',
        body,
        params
    }
    return Api.sendRequest(request)
}
function tgBotPoll(body, params = {}) {
    const request = {
        method: 'post',
        path: 'user/sign-in/tg-bot-poll',
        body,
        params
    }
    return Api.sendRequest(request)
}

function miniappVerify(body, params = {}) {
    const request = {
        method: 'post',
        path: 'user/miniapp/verify',
        body,
        params
    }
    return Api.sendRequest(request)
}

function miniappLink(body, params = {}) {
    const request = {
        method: 'post',
        path: 'user/miniapp/link',
        body,
        params
    }
    return Api.sendRequest(request)
}

function miniappAutoRegister(body, params = {}) {
    const request = {
        method: 'post',
        path: 'user/miniapp/auto-register',
        body,
        params
    }
    return Api.sendRequest(request)
}

function getKeyForTg(body, params = {}) {
    const request = {
        method: 'get',
        path: 'user/profile/get-auth-key',
        body,
        params

    }
    return Api.sendRequest(request)
}

function getCdnKey(params) {
    const request = {
        method: 'get',
        path: 'user/default/get-cdn-key',
        params: params
    }
    return Api.sendRequest(request)
}

async function setTimezone(params) {
    const request = {
        method: 'post',
        path: 'user/profile/set-time-zone',
        params: params
    }

    return Api.sendRequest(request)
}
async function setReportCurrency(params) {
    const request = {
        method: 'post',
        path: 'user/profile/set-report-currency',
        params: params
    }

    return Api.sendRequest(request)
}



async function setEmail(body) {
    const request = {
        method: 'post',
        path: 'user/profile/set-email',
        body: body
    }

    return Api.sendRequest(request)
}

async function sendEmailCode(params) {
    const request = {
        method: 'post',
        path: 'user/profile/email-code',
        params: params
    }

    return Api.sendRequest(request)
}

async function resolveEmailConflict(params) {
    const request = {
        method: 'post',
        path: 'user/profile/resolve-email-conflict',
        params: params
    }

    return Api.sendRequest(request)
}

async function setPassword(body) {
    const request = {
        method: 'post',
        path: 'user/profile/set-password',
        body
    }

    return Api.sendRequest(request)
}

async function setCurrency(params) {
    const request = {
        method: 'post',
        path: 'user/profile/set-currency',
        params: params
    }

    return Api.sendRequest(request)
}

async function setLang(params) {
    const request = {
        method: 'post',
        path: 'user/profile/set-lang',
        params: params
    }

    return Api.sendRequest(request)
}

async function setAnalyticsIds(params) {
    const request = {
        method: 'post',
        path: 'user/profile/set-analytics-ids',
        params: params
    }

    return Api.sendRequest(request)
}
